export const FULL_TRUCKLOAD = "LTL/FTL Shipment"
export const FULL_TRUCKLOAD_BROKERS = "LTL/FTL Shipment Brokers"
export const FULL_TRUCKLOAD_SIGNATURES = "LTL/FTL Signatures"
export const FULL_TRUCKLOAD_CARRIERS = "LTL/FTL Shipment Carriers"
export const FULL_TRUCKLOAD_SETTINGS = "LTL/FTL Settings"

export const FTL_PAGES = {
    TABLE: "table",
    SETTINGS: "settings",
    SETUP: "documents",
    CREATE: "create",
    UPDATE: "update",
    UPLOAD: "upload",
    PREVIEW: "preview",
    CUSTOMS_BROKERS: "CUSTOMS BROKERS",
    SIGNATURES: "SIGNATURES",
    NOA_PORTS: "PORTS OF ENTRY",
}

export const CREATE_FTL = "Create Shipment"
export const CREATE_NEW_BROKER = "New Broker"
export const CREATE_NEW_CARRIER = "New Carrier"
export const FTL_SETUP = "Shipment Setup"
export const FTL_EXPORT = "Download FTL Plan"
export const REGENERATE_DOCUMENT = "Regenerate Document"
export const ADD_BROKER = "Add Broker"
export const ADD_CARRIER = "Add Carrier"

export const MARK_DRAFT_FTL = "Mark as Draft"
export const APPROVE_FTL = "Approve Truckload"
export const UNAPPROVE_FTL = "Unapprove Truckload"
export const MARK_FTL_UNSHIPPED = "Mark as Unshipped"
export const MARK_FTL_SHIPPED = "Mark as Shipped"
export const MARK_FTL_INCOMPLETE = "Mark as Incomplete"
export const MARK_FTL_COMPLETE = "Mark as Completed"
export const VIEW_DOCUMENTS = "View Documents"
export const VIEW_BOL = "View Bill of Lading"

export const FULL_TRUCKLOAD_TABLE_HEADERS = [
    { id: 'shipDate', text: 'Ship Date' },
    { id: 'receivedDate', text: 'Receive Date' },
    { id: 'deliveryDate', text: 'Delivery Date'},
    { id: 'carrierName', text: 'Carrier Name' },
    { id: 'shipFrom', text: 'Ship From' },
    { id: 'shipTo', text: 'Ship To' },
    { id: 'shipmentNumber', text: 'Shipment Number' },
    { id: 'status', text: 'Status' },
]

export const FULL_TRUCKLOAD_BROKERS_TABLE =[
    { id: 'name', text: 'Company Name' },
    { id: 'contactName', text: 'Contact Name' },
    { id: 'email', text: 'Email' },
    { id: 'phoneNumber', text: 'Phone Number' },
    { id: 'accountNumber', text: 'Account Number' },
    { id: 'addressLine1', text: 'Address Line1' },
]

export const FULL_TRUCKLOAD_CARRIERS_TABLE =[
    { id: 'companyName', text: 'companyName' },
    { id: 'contactName', text: 'contactName' },
    { id: 'email', text: 'email' },
    { id: 'phoneNumber', text: 'phoneNumber' },
    { id: 'location', text: 'location' },
    { id: 'accountNumber', text: 'accountNumber' },
    { id: 'addressLine1', text: 'addressLine1' },
]

export const EDIT = "Edit"
export const DELETE = "Delete"

export const FTL_STEPPER_HEADINGS = ["Plan", "Shipment Items", "Shipper & Consignee Info", "Documents Info", "Additional Documents"]
export const FTL_STEPPER_HEADING_DESCRIPTIONS = ["Make the shipment plan", "Add items to this shipment", "Add shipper and consignee information", "Add information for Bill of Lading and Commercial Invoice", "Add additional documents to this shipment"]

export const STEP_FTL_PLAN_INDEX = 0
export const STEP_FTL_ITEMS_INDEX = 1
export const STEP_FTL_ADDRESS_INDEX = 2
export const STEP_FTL_BOL_INDEX = 3
export const STEP_FTL_DOCUMENTS_INDEX = 4

export const CANCEL = "Cancel"
export const BACK = "Back"
export const NEXT = "Next"
export const GENERATE = "Generate"
export const SAVE_DRAFT = "Save As Draft"
export const REQUEST_FOR_APPROVAL = "Request Approval"
export const SAVE = "Save"

export const UPLOAD_BOL_AND_CI = "Upload BOL and CI"
export const DOWNLOAD = "Download"
export const PRINT = "Print"
export const ZOOM_IN = "Zoom In"
export const ZOOM_OUT = "Zoom Out"
export const UPLOAD_FILE = "Upload file"
export const SHIP = "Ship"
export const DElIVERY = "Delivery"
export const TIME_IN = "Time In"
export const TIME_OUT = "Time Out"

export const SHIPPER = "Shipper"
export const CONSIGNEE = "Consignee"

export const NEW_BROKER = "New Broker"
export const NEW_CARRIER = "New Carrier"

export const FTL_FORM_TABLE_HEADERS = [
    { id: 'shortcode', numeric: false, disablePadding: false, label: 'Shortcode', width: "14%", textAlign: "center"},
    { id: 'supplier', numeric: false, disablePadding: false, label: 'Supplier', width: "14%", textAlign: "center"},
    { id: 'manufacturerPartNum', numeric: false, disablePadding: false, label: 'Manufacturer Part Number', width: "10%", textAlign: "center"},
    { id: 'quantity', numeric: false, disablePadding: false, label: 'Quantity', width: "6%", textAlign: "right"},
    { id: 'numOfSkids', numeric: false, disablePadding: false, label: 'Number of Skids', width: "8%", textAlign: "center"},
    { id: 'fromLocationUnitInHandAfterTransfer', numeric: false, disablePadding: false, label: 'Units in hand after transfer', width: "10%", textAlign: "center"},
    { id: 'fromLocationDaysOfCoverageAfterTransfer', numeric: false, disablePadding: false, label: 'Days of coverage after transfer', width: "10%", textAlign: "center"},
    { id: 'toLocationUnitInHandAfterTransfer', numeric: false, disablePadding: false, label: 'Units in hand after transfer', width: "10%", textAlign: "center"},
    { id: 'toLocationDaysOfCoverageAfterTransfer', numeric: false, disablePadding: false, label: 'Days of coverage after transfer', width: "10%", textAlign: "center"},
    { id: 'sample', numeric: false, disablePadding: false, label: 'Sample', width: "6%", textAlign: "left"},
];

export const FTL_FORM_TABLE_HEADERS_EXCLUDE_TRANSFER_COLUMNS = [
    { id: 'shortcode', numeric: false, disablePadding: false, label: 'Shortcode', width: "15%", textAlign: "center"},
    { id: 'supplier', numeric: false, disablePadding: false, label: 'Supplier', width: "16%", textAlign: "center"},
    { id: 'manufacturerPartNum', numeric: false, disablePadding: false, label: 'Manufacturer Part Number', width: "15%", textAlign: "center"},
    { id: 'quantity', numeric: false, disablePadding: false, label: 'Quantity', width: "10%", textAlign: "center"},
    { id: 'numOfSkids', numeric: false, disablePadding: false, label: 'Number of Skids', width: "10%", textAlign: "center"},
    { id: 'sample', numeric: false, disablePadding: false, label: 'Sample', width: "10%", textAlign: "left"},
];

export const ADD_FTL_ENTRY = "Add an entry to the FTL"
export const REMOVE_FTL_ENTRY = "Remove entry"

export const PARTIES_TO_TRANSACTION_OPTIONS = ["Related", "Non-Related"]
export const DUTIES_TAXES_PAYABLE_BY_OPTIONS = ["Exporter", "Importer", "Other"]
export const SHIPMENT_TERMS_OPTIONS = ["F.O.B", "C&F", "CIF"]
export const CURRENCY_OF_SALE_OPTIONS = ["CAD", "USD"]

export const FTL_STEPPER_DOCUMENTS_HELPER_TEXT = "Select or upload documents to include in this shipment:"
export const FTL_STEPPER_UPLOAD_DOCUMENTS = "Upload additional documents to include in this shipment"
export const DRAG = "Drag"

export const FTL_STATUSES = {
    DRAFT: "Draft",
    REQUEST_APPROVAL: "Approval Requested",
    APPROVED: "Approved",
    SHIPPED: "Shipped",
    RECEIVED: "Received",
    COMPLETED: "Completed"
}

export const FTL_DOC_TYPES = {
    BILL_OF_LADING: "billOfLading",
    COMMERCIAL_INVOICE: "commercialInvoice",
    FINAL_DOCUMENT: "finalDocument"

}

export const COUNTRY_OPTIONS = [
    "Canada",
    "United States",
    "Mexico",
    "China",
    "United Arab Emirates"
]

export const FTL_SETUP_HELPER_TEXT = "Add documents and specify shortcodes related to the document, if any:"
export const FTL_SIGNATURES_HELPER_TEXT = "Add documents and specify name related to the document"

export const FTL_SETUP_TABLE_HEADERS = [
    { id: 'shortcodes', numeric: false, disablePadding: false, label: 'Shortcodes', width: "14%", paddingLeft: "1.8%" },
    { id: 'supplierName', numeric: false, disablePadding: false, label: 'Supplier', width: "16%" },
    { id: 'type', numeric: false, disablePadding: false, label: 'Document Type', width: "18%" },
    { id: 'location', numeric: false, disablePadding: false, label: 'Location', width: "13%" },
    { id: 'defaultSignature', numeric: false, disablePadding: false, label: 'Default Signature', width: "13%"},
    { id: 'sample', numeric: false, disablePadding: false, label: 'Required for Domestic Shipments', width: "7.8%" },
    { id: 'sample', numeric: false, disablePadding: false, label: 'Required for International Shipments', width: "7.8%" },
    { id: 'sequence', numeric: false, disablePadding: false, label: 'Document Sequence', width: "5%" },
];

export const FTL_SIGNATURES_TABLE_HEADERS = [
    { id: '', numeric: false, disablePadding: false, label: '', width: "10%", textAlign:"center" },
    { id: 'name', numeric: false, disablePadding: false, label: 'Full Name', width: "25%", textAlign:"center" },
    { id: 'position', numeric: false, disablePadding: false, label: 'Position', width: "25%", textAlign:"center" },
    { id: 'signatureFile', numeric: false, disablePadding: false, label: 'Signature File', width: "32%", textAlign:"center" },
    { id: 'isDefault', numeric: false, disablePadding: false, label: 'Default', width: "10%", textAlign:"left" },

]

export const FTL_NOA_PORTS_TABLE_HEADERS = [
    { id: '', numeric: false, disablePadding: false, label: '', width: "10%" },
    { id: 'portOfEntry', numeric: false, disablePadding: false, label: 'Port of Entry', width: "22.5%" },
    { id: 'city', numeric: false, disablePadding: false, label: 'City', width: "22.5%" },
    { id: 'state', numeric: false, disablePadding: false, label: 'State / Province', width: "22.5%" },
    { id: 'country', numeric: false, disablePadding: false, label: 'Country', width: "22.5%" },
]

export const FTL_ADDITIONAL_DOCUMENTS_TABLE_HEADERS = [
    { id: 'attachment', numeric: false, disablePadding: false, label: 'Document', width: "20%" },
]

export const FTL_DOCUMENT_TYPES = [
    "EPA Pesticides Disclaimer",
    "EPA Notice Of Arrival (NOA)",
    "USMCA / CUSMA",
    "Product Details",
/*
    "Notice Of Arrival (NOA)",
*/
    "U.S. Goods Returned (USGR)",
    "Foreign Shipper's Declaration (FSD)",
    "Other"
]

export const REMOVE_PORT = "Remove Port"
export const REMOVE_DOCUMENT = "Remove Document"
export const REMOVE_SIGNATURE = "Remove Signature"
export const ADD_DOCUMENT = "Add Document"
export const ADD_SIGNATURE = "Add Signature"
export const ADD_PORT = "Add Port"
export const BILL_OF_LADING = "Upload signed Bill of Lading (BOL)."
export const COMMERCIAL_INVOICE = "Upload signed Commercial Invoice."

export const FTL_CARRIER_MISSING_MESSAGE = "Missing carrier name, save failed"
export const FTL_BROKER_MISSING_MESSAGE = "Missing broker name, save failed, please select - if no broker is involved"
export const FTL_POA_MISSING_MESSAGE = "Missing port of entry, save failed"

export const FTL_SAVED_SUCCESSFUL_MESSAGE = "FTL saved"
export const FTL_UPDATED_SUCCESSFUL_MESSAGE = "FTL updated"
export const FTL_MARKED_AS_DRAFT_MESSAGE = "FTL marked as draft"
export const FTL_UNAPPROVED_MESSAGE = "FTL unapproved"
export const FTL_MARKED_AS_UNSHIPPED_MESSAGE = "FTL marked as unshipped"
export const FTL_MARKED_AS_INCOMPLETE_MESSAGE = "FTL marked as incomplete"
export const FTL_MARKED_AS_COMPLETE_MESSAGE = "FTL marked as complete"
export const FTL_MARKED_AS_SHIPPED_MESSAGE = "FTL marked as shipped"
export const FTL_APPROVED_MESSAGE = "FTL approved"
export const FTL_DELETE_SUCCESSFUL_MESSAGE = "FTL deleted"
export const FTL_SETTING_SAVE_SUCCESSFUL_MESSAGE = "FTL Setting Saved"